import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=45442dd6&scoped=true&"
import script from "@/scripts/Setting/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Setting/index.js?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=45442dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45442dd6",
  null
  
)

export default component.exports